export enum LicenseClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  NO_CDL = 'NO_CDL',
}

export const LicenseClassLabels = {
  [LicenseClass.A]: 'A',
  [LicenseClass.B]: 'B',
  [LicenseClass.C]: 'C',
  [LicenseClass.D]: 'D',
  [LicenseClass.E]: 'E',
  [LicenseClass.NO_CDL]: 'No CDL',
}

export enum MexicanLicenseClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}

export const MexicanLicenseClassLabels = {
  [MexicanLicenseClass.A]: 'A - Passenger and Tourism',
  [MexicanLicenseClass.B]: 'B - Freight',
  [MexicanLicenseClass.C]: 'C - Freight Two or Three Axles',
  [MexicanLicenseClass.D]: 'D - Tourism',
  [MexicanLicenseClass.E]: 'E - Freight Hazardous Materials',
  [MexicanLicenseClass.F]: 'F - Passenger Ports and Airports',
}

// CCMTA classes used by most provinces (including Alberta). Ontario/Quebec
// letter classes are not modeled separately — Class 1 is the tractor-trailer
// equivalent of Ontario A.
export enum CanadianLicenseClass {
  CLASS_1 = 'CLASS_1',
  CLASS_2 = 'CLASS_2',
  CLASS_3 = 'CLASS_3',
  CLASS_4 = 'CLASS_4',
  CLASS_5 = 'CLASS_5',
  CLASS_6 = 'CLASS_6',
}

export const CanadianLicenseClassLabels = {
  [CanadianLicenseClass.CLASS_1]: '1 - Tractor-Trailer',
  [CanadianLicenseClass.CLASS_2]: '2 - Bus',
  [CanadianLicenseClass.CLASS_3]: '3 - Straight Truck',
  [CanadianLicenseClass.CLASS_4]: '4 - Taxi, Ambulance, Small Bus',
  [CanadianLicenseClass.CLASS_5]: '5 - Passenger Vehicle',
  [CanadianLicenseClass.CLASS_6]: '6 - Motorcycle',
}

export const AllLicenseClassValues = {
  ...LicenseClass,
  ...MexicanLicenseClass,
  ...CanadianLicenseClass,
}

export enum Endorsement {
  H = 'H',
  N = 'N',
  X = 'X',
  P = 'P',
  S = 'S',
  T = 'T',
  V = 'V',
  L = 'L',
  M = 'M',
}

export const EndorsementDescriptions = {
  [Endorsement.H]: 'Hazardous Materials (Hazmat)',
  [Endorsement.N]: 'Tank Vehicles',
  [Endorsement.X]: 'Combination of Tank Vehicle and Hazardous Materials',
  [Endorsement.P]: 'Passenger Vehicles',
  [Endorsement.S]: 'School Buses',
  [Endorsement.T]: 'Double/Triple Trailers',
  [Endorsement.V]: 'Tank Vehicles Carrying Hazardous Materials',
  [Endorsement.L]: 'Air Brake Restriction',
  [Endorsement.M]: 'Metal Coil',
}

export const licenseClassOptions: { value: LicenseClass; label: string }[] =
  Object.values(LicenseClass).map((value) => ({
    value,
    label: LicenseClassLabels[value] ?? value,
  }))

export const endorsementOptions: { value: Endorsement; label: string }[] =
  Object.values(Endorsement).map((value) => ({
    value,
    label: `${value} — ${EndorsementDescriptions[value]}`,
  }))
